// extracted by mini-css-extract-plugin
export default {"card":"card-card-cy7gea","header":"card-header-VViYvp","body":"card-body-ixwAgC"};